export const INVENTORY_EXCLUDE_ATTRIBUTE = 'data-leo-inventory-exclude';

export const MAX_LABELS = 20;

export const MAX_READ_SERIES = 8;

export const MAX_READ_POINTS = 100;

export const MAX_READ_ROWS = 50;
